// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-iam-access-dialog-resource-info {
  display: flex;
  align-items: center;
}
.dl-iam-access-dialog-resource-info__icon {
  min-width: 20px;
}
.dl-iam-access-dialog-resource-info__icon .shared-entry-icon-box {
  width: 20px;
  height: 20px;
}
.dl-iam-access-dialog-resource-info__title {
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/IamAccessDialog/ResourceInfo/ResourceInfo.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;AACJ;AACI;EACI,eAAA;AACR;AAAQ;EACI,WAAA;EACA,YAAA;AAEZ;AAEI;EACI,gBAAA;AAAR","sourcesContent":[".dl-iam-access-dialog-resource-info {\n  display: flex;\n  align-items: center;\n}\n.dl-iam-access-dialog-resource-info__icon {\n  min-width: 20px;\n}\n.dl-iam-access-dialog-resource-info__icon .shared-entry-icon-box {\n  width: 20px;\n  height: 20px;\n}\n.dl-iam-access-dialog-resource-info__title {\n  margin-left: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
